import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { useActivity } from '@queries';
import { activityIdAtom } from '@store';

const MAX_TAGS = 1;

export const useNavigationActivityTags = () => {
    const activityId = useAtomValue(activityIdAtom);
    const { data: activity } = useActivity(activityId);

    const currentTags = useMemo(() => {
        const tags = activity?.tags || [];
        if (!tags.length) {
            return [];
        }

        if (tags.length <= MAX_TAGS) {
            return tags.map((tag) => ({ label: tag.name }));
        }

        return [
            ...tags.slice(0, MAX_TAGS).map((tag) => ({ label: tag.name })),
            { label: `+${tags.length - MAX_TAGS}` },
        ];
    }, [activity]);

    return { currentTags, activityTags: activity?.tags };
};
